(function (){
    'use strict';

    angular
        .module('app')
        .directive('emailValidate', emailValidate);

    emailValidate.$inject = ['FindClientsService'];

    function emailValidate(FindClientsService) {
       return {
           restrict:'A',
          // templateUrl: 'templates/directives/validate/emailTemplate.html',
           require:'ngModel',
           scope:{
               cod: '='
           },
           link:link,

       }


        function link(scope, element, attrs, ctrl) {

            element.bind("focus", function() {
                var validator = function(value) {
                    //var regExp = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
                    var regExp = /^([\w-']+(?:\.[\w-']+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
                    var service = [];
                    var serviceCod = [];


                    if(typeof ctrl.$viewValue !== 'undefined' && ctrl.$viewValue !== 'NaN' && ctrl.$viewValue !=='') {
                        FindClientsService.getByEmail(ctrl.$viewValue).then(function (response) {
                            var service = response.data;

                            if (!regExp.test(ctrl.$viewValue)) {
                                ctrl.$setValidity('emailValidate', false);
                                angular.element(element.parent().removeClass('has-error'));
                                angular.element(element.parent().find("span").remove());
                                angular.element(element.parent().addClass('has-error'));
                                angular.element(element.parent().append("<span class='help-block'>This email is not valids!</span>"));
                            } else {
                                ctrl.$setValidity('emailValidate', true);
                                angular.element(element.parent().removeClass('has-error'));
                                angular.element(element.parent().find("span").remove());
                            }


                            if (typeof service[0] !== 'undefined' && typeof ctrl.$viewValue !== 'undefined' && ctrl.$viewValue !== 'NaN') {
                                serviceCod = service[0].id;
                                if (serviceCod != scope.cod && ctrl.$viewValue !== '') {
                                    ctrl.$setValidity('emailValidate', false);
                                    angular.element(element.parent().removeClass('has-error'));
                                    angular.element(element.parent().find("span").remove());
                                    angular.element(element.parent().addClass('has-error'));
                                    angular.element(element.parent().append("<span class='help-block'>This can not be done at this time because this email is already being used. Please try a different email.</span>"));
                                } else {
                                    ctrl.$setValidity('emailValidate', true);
                                    angular.element(element.parent().removeClass('has-error'));
                                    angular.element(element.parent().find("span").remove());
                                }
                            }
                            ctrl.$setViewValue(ctrl.$viewValue);
                            ctrl.$render();
                        });

                    }
                    return value;
                };
                ctrl.$parsers.unshift(validator);
                ctrl.$formatters.unshift(validator);
            });
        }
    }
})();